import { useEffect, useState } from 'react';
import { Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Blog = ({ isDarkMode }) => {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPosts = async (pageNumber = 1) => {
    try {
      setLoading(true);

      const SITE_ID = 1;

      const response = await fetch(
          `https://digitalcontentengine.com/v1/posts?site_id=${SITE_ID}&page=${pageNumber}&per_page=12`
      );

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      setPosts(data.data);
      setMeta(data.meta);
      setPage(pageNumber);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPosts(1);
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
      // Wrapper adds safe space above footer
      <div className="blog-page pb-5">
        {/* container also gets bottom padding so cards/buttons never butt up against footer */}
        <div className="container mt-4 pb-4">
          <h1 className={`blog-title ${isDarkMode ? 'text-white' : ''}`}>Blog</h1>
          <p className={isDarkMode ? 'text-white-50' : 'text-muted'}>
            Articles, guides, and insights.
          </p>

          <div className="row d-flex align-items-stretch">
            {posts.map((post) => (
                <div key={post.id} className="col-md-4 mb-4">
                  <Card
                      className={`h-100 d-flex flex-column ${
                          isDarkMode ? 'bg-dark text-white' : ''
                      }`}
                  >
                    <Card.Img variant="top" src={post.image_url} alt={post.title} loading="lazy" />
                    <Card.Body className="d-flex flex-column">
                      <Card.Title>{post.title}</Card.Title>
                      <Card.Text className="flex-grow-1">{post.excerpt}</Card.Text>

                      {/* Button pinned to bottom */}
                      <Link to={`/blog/${post.slug}`} className="btn btn-primary mt-auto">
                        Read More
                      </Link>
                    </Card.Body>
                  </Card>
                </div>
            ))}
          </div>

          {/* Pagination (extra bottom margin so it never visually collides with footer) */}
          {meta && (
              <div className="d-flex justify-content-center gap-2 mt-4 mb-5">
                <Button
                    variant="secondary"
                    disabled={page <= 1}
                    onClick={() => fetchPosts(page - 1)}
                >
                  Previous
                </Button>

                <span className={`align-self-center ${isDarkMode ? 'text-white' : ''}`}>
              Page {meta.current_page} of {meta.last_page}
            </span>

                <Button
                    variant="secondary"
                    disabled={page >= meta.last_page}
                    onClick={() => fetchPosts(page + 1)}
                >
                  Next
                </Button>
              </div>
          )}
        </div>
      </div>
  );
};

export default Blog;
